import champsTiersTranslator from './champsTiersTranslator';

export default function translate(i18n, propriete) {
  return champsTiersTranslator(i18n, propriete, 'editionFournisseur');
}
